import { render } from "./icon-material.vue?vue&type=template&id=1098f778"
import script from "./icon-material.vue?vue&type=script&lang=js"
export * from "./icon-material.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__